import apiFetch from '../apiFetch'

export default function (idInformePersonalizado, token) {
  return apiFetch({endPoint: `Informes/getCargarSeleccionInformePersonalizado?idInformePersonalizado=` + idInformePersonalizado, method: 'GET', body: null, token: token})
}